<template>
  <b-modal
    id="modal-route-planing"
    ref="modal-route-planing"
    size="sm"
    modal-class="
        mc-modal-info mc-modal-info--route-planing
      "
    hide-header
    hide-footer
    scrollable
    no-close-on-backdrop
    hide-backdrop
    centered
    no-enforce-focus
    @show="showModal"
  >
    <h4 class="mc-modal-info__head">
      {{ $t('route.routeList') }}
      <i class="mc-fa icon-outline_close" @click="close"></i>
    </h4>
    <div class="mc-modal-info--route-wrapper">
      <b-alert
        show
        variant="primary"
        class="mc-alert d-flex justify-content-start mt-3 font-size-12"
      >
        <i class="mc-fa icon-fill_info"></i>
        <span class="mc-alert__text">{{ $t('route.tooltipRoutePlaning') }}</span>
      </b-alert>
      <p class="mc-sidebar-liveview__filter-show mt-2 mb-0">
        {{ $t('global.show') }} <strong>{{ items.length }}</strong> {{ $t('master.rute') }}.
      </p>
      <b-list-group class="mc-sidebar-liveview__list-fleet">
        <b-list-group-item v-for="(row, index) in items" :key="index">
          <div class="clearfix">
            <span class="pull-left">{{ row.route.name }}</span>
            <b-badge v-if="row.status === 'progress'" class="bg-info">{{
              $t('master.status.dalamPerjalanan')
            }}</b-badge>
            <b-badge v-else-if="row.status === 'done'" class="bg-success">{{
              $t('master.status.selesai')
            }}</b-badge>
            <b-badge v-else-if="row.status === 'scheduled'" class="bg-secondary">{{
              $t('master.status.dijadwalkan')
            }}</b-badge>
            <b-badge v-else-if="row.status === 'cancelled'" class="bg-danger">{{
              $t('master.status.dibatalkan')
            }}</b-badge>
          </div>
          <div class="mc-sidebar-liveview__list-fleet-showhide">
            <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
              <div>
                <p>{{ momentDMY_HI(row.expectedStartOn) }}</p>
              </div>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-modal>
</template>
<script>
import responsive from '@/mixin/responsive'
import { GET_ROUTE_RECORDS } from '@/services/api/route'
import { Helper } from '@/mixin/helper'

export default {
  name: 'ModalRoutePlaning',
  mixins: [Helper, responsive],
  props: {
    vehicleId: Number,
  },
  data() {
    return {
      items: [],
    }
  },
  watch: {
    vehicleId: {
      async handler(val) {
        const res = await this.$apollo.query({
          fetchPolicy: 'no-cache',
          query: GET_ROUTE_RECORDS,
          variables: {
            filter: {
              vehicleId: val,
            },
          },
        })

        this.items = res.data.routeRecords.routeRecords.data
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async showModal() {
      this.$bvModal.hide('modal-fleet-planing')
      this.$store.commit('map/MODAL_FLEETPLANNING', false)
    },
    close() {
      this.$bvModal.hide('modal-route-planing')
      this.$store.commit('map/MODAL_ROUTEPLANNING', false)
    },
  },
}
</script>
